module.exports = __webpack_public_path__ + "static/media/brushCard.09ea066a.png";